import React from 'react';
import { stringToMarkdown } from '../../common/stringTypes.js';
import { MarkdownPresenter } from './MarkdownPresenter.js';
import { ShowMore } from './ShowMore.js';
import style from './ProductBrandDescription.scss';
export const ProductBrandDescription = ({ description }) => (React.createElement(ShowMore, null,
    React.createElement(MarkdownPresenter, { className: style.productBrandDescription, markdownContent: stringToMarkdown(description) })));
